






























import { Http } from "fs-pb-vue2/services/api/http";
import { clientTime } from "fs-pb-vue2/utilities";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { ConfigStore } from "fs-pb-vue2/store/modules/config";

@Component
export default class EsiaClientDataConfirm extends Vue {
  @Prop() rawClientData!: any

  @Watch("rawClientData", { immediate: true })
  rawClientDataChanged(rawClientData: any) {
    this.fillValues(rawClientData);
  }

  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  get PersonalDataRules(): string {
    return this.configStore.apiData.PersonalDataRulesFile;
  }

  displayClientData: any[] = []
  isAccepted: boolean = false
  country_dict: any = { 'RUS': 'Россия' };
  documentType_dict: any = { 'RF_PASSPORT': 'Пасспорт РФ' };
  floor_dict: any = { 'M': 'Мужской', 'F': 'Женский' }

  fillValues(data: any): void {
    if (!data || !data.info)
      return;

    this.displayClientData = [
      {
        title: 'Подтвердите ваши персональные данные',
        data: [
          {
            name: 'ИНН',
            value: data.info.inn
          },
          {
            name: 'Фамилия',
            value: data.info.lastName
          },
          {
            name: 'Имя',
            value: data.info.firstName
          },
          {
            name: 'Отчество',
            value: data.info.middleName
          },
          {
            name: 'Пол',
            value: this.variableToLocale(data.info.gender, this.floor_dict)
          },
          {
            name: 'Дата рождения',
            value: data.info.birthDate
          }
        ]
      },
      {
        title: 'Документы клиента',
        data: [
          {
            name: 'Тип документа',
            value: !data.info.documents.rf_passport[0] || !data.info.documents.rf_passport[0].type ? "" : this.variableToLocale(data.info.documents.rf_passport[0].type, this.documentType_dict)
          },
          {
            name: 'Серия',
            value: !data.info.documents.rf_passport[0] || !data.info.documents.rf_passport[0].series ? "" : data.info.documents.rf_passport[0].series
          },
          {
            name: 'Номер',
            value: !data.info.documents.rf_passport[0] || !data.info.documents.rf_passport[0].number ? "" : data.info.documents.rf_passport[0].number
          },
          {
            name: 'Дата выдачи',
            value: !data.info.documents.rf_passport[0] || !data.info.documents.rf_passport[0].issueDate ? "" : data.info.documents.rf_passport[0].issueDate
          },
          {
            name: 'Кем выдан',
            value: !data.info.documents.rf_passport[0] || !data.info.documents.rf_passport[0].issuedBy ? "" : data.info.documents.rf_passport[0].issuedBy
          },
          {
            name: 'Код подразделения',
            value: !data.info.documents.rf_passport[0] || !data.info.documents.rf_passport[0].issueId ? "" : data.info.documents.rf_passport[0].issueId
          },
          {
            name: 'Гражданство',
            value: !data.info.documents.rf_passport[0] || !data.info.documents.rf_passport[0].citizenship ? "" : this.variableToLocale(data.info.citizenship, this.country_dict)
          },
          {
            name: 'Страна',
            value: !data.info.documents.rf_passport[0] || !data.info.documents.rf_passport[0].citizenship ? "" : this.variableToLocale(data.info.citizenship, this.country_dict)
          }
        ]
      },
      {
        title: 'Адрес регистрации',
        data: [
          {
            name: 'Город',
            value: !data.info.addresses.prg || !data.info.addresses.prg.city ? "" : data.info.addresses.prg.city
          },
          {
            name: 'Индекс',
            value: !data.info.addresses.prg || !data.info.addresses.prg.zipCode ? "" : data.info.addresses.prg.zipCode
          },
          {
            name: 'Регион',
            value: !data.info.addresses.prg || !data.info.addresses.prg.region ? "" : data.info.addresses.prg.region
          },
          {
            name: 'Район',
            value: !data.info.addresses.prg || !data.info.addresses.prg.area ? "" : data.info.addresses.prg.area
          },
          {
            name: 'Населенный пункт',
            value: !data.info.addresses.prg || !data.info.addresses.prg.settlement ? "" : data.info.addresses.prg.settlement
          },
          {
            name: 'Улица',
            value: !data.info.addresses.prg || !data.info.addresses.prg.street ? "" : data.info.addresses.prg.street
          },
          {
            name: 'Дом',
            value: !data.info.addresses.prg || !data.info.addresses.prg.house ? "" : data.info.addresses.prg.house
          },
          {
            name: 'Корпус',
            value: !data.info.addresses.prg || !data.info.addresses.prg.frame ? "" : data.info.addresses.prg.frame
          },
          {
            name: 'Строение',
            value: !data.info.addresses.prg || !data.info.addresses.prg.building ? "" : data.info.addresses.prg.building
          },
          {
            name: 'Помещение/Квартира',
            value: !data.info.addresses.prg || !data.info.addresses.prg.flat ? "" : data.info.addresses.prg.flat
          }
        ]
      },
      {
        title: 'Адрес проживания',
        data: [
          {
            name: 'Город',
            value: !data.info.addresses.plv || !data.info.addresses.plv.city ? "" : data.info.addresses.plv.city
          },
          {
            name: 'Индекс',
            value: !data.info.addresses.plv || !data.info.addresses.plv.zipCode ? "" : data.info.addresses.plv.zipCode
          },
          {
            name: 'Регион',
            value: !data.info.addresses.plv || !data.info.addresses.plv.region ? "" : data.info.addresses.plv.region
          },
          {
            name: 'Район',
            value: !data.info.addresses.plv || !data.info.addresses.plv.area ? "" : data.info.addresses.plv.area
          },
          {
            name: 'Населенный пункт',
            value: !data.info.addresses.plv || !data.info.addresses.plv.settlement ? "" : data.info.addresses.plv.settlement
          },
          {
            name: 'Улица',
            value: !data.info.addresses.plv || !data.info.addresses.plv.street ? "" : data.info.addresses.plv.street
          },
          {
            name: 'Дом',
            value: !data.info.addresses.plv || !data.info.addresses.plv.house ? "" : data.info.addresses.plv.house
          },
          {
            name: 'Корпус',
            value: !data.info.addresses.plv || !data.info.addresses.plv.frame ? "" : data.info.addresses.plv.frame
          },
          {
            name: 'Строение',
            value: !data.info.addresses.plv || !data.info.addresses.plv.building ? "" : data.info.addresses.plv.building
          },
          {
            name: 'Помещение/Квартира',
            value: !data.info.addresses.plv || !data.info.addresses.plv.flat ? "" : data.info.addresses.plv.flat
          }
        ]
      },
      {
        title: 'Контактная информация',
        data: [
          {
            name: 'Номер телефона',
            value: data.info.mobile
          },
          {
            name: 'Электронная почта',
            value: data.info.email
          },
          {
            name: 'СНИЛС',
            value: data.info.snils
          }
        ]
      }
    ];
  }

  variableToLocale(variable: any, dictionary: any) {
    let result = variable;

    for (const key in dictionary) {
      if (dictionary[key] && key === variable) {
        result = dictionary[key];
      }
    }

    return result;
  }

  accept(): void {
    this.$emit("accepted");
  }
}
